import { useProfilePreview } from "PFApp/use_profile_preview";
import { Id } from "PFTypes";
import { Dispatch, SetStateAction, useCallback } from "react";

import { useSkillsManagementContext } from "../contexts/skills_management_context_provider";

type UseSkillManagementSidePanelReturn = {
  openSidePanel: (skill: Id) => void;
  closeSidePanel: () => void;
  sidePanelSkillId: Id | null;
  setSidePanelSkillId: Dispatch<SetStateAction<Id | null>>;
  isSidePanelOpen: boolean;
};

export const useSkillManagementSidePanel = (): UseSkillManagementSidePanelReturn => {
  const {
    sidePanel: { setIsSidePanelOpen, setSidePanelSkillId, sidePanelSkillId, isSidePanelOpen }
  } = useSkillsManagementContext();
  const { hidePreview } = useProfilePreview();

  const openSidePanel = useCallback(
    (skillId: Id) => {
      hidePreview();
      setSidePanelSkillId(skillId);
      setIsSidePanelOpen(true);
    },
    [hidePreview, setIsSidePanelOpen, setSidePanelSkillId]
  );

  const closeSidePanel = useCallback(() => {
    setIsSidePanelOpen(false);
    setSidePanelSkillId(null);
  }, [setIsSidePanelOpen, setSidePanelSkillId]);

  return { openSidePanel, closeSidePanel, sidePanelSkillId, isSidePanelOpen, setSidePanelSkillId };
};
